<template>
  <p v-if="message">
    {{ message }}
  </p>
</template>

<script setup lang="ts">
  defineProps({
    message: { type: String, default: '' },
  });
</script>
